module.exports = __webpack_public_path__ + "static/media/shipping-fast.c49221c8.svg";